import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

export const getPatient = (state, id) => singleModelSelector(state, 'Patient', id);
export const getAllPatients = (state) => allModelsSelector(state, 'Patient');
